import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundary} from "react-error-boundary";

const OddsMovementsWidgetAsyncComponent = AsyncComponent(async () => import('./odds-movements-widget' /* webpackChunkName: "odds-movements-widget" */ ));

export const OddsMovementsWidgetAsync = (props) => {
  return <ErrorBoundary><OddsMovementsWidgetAsyncComponent {...props}/></ErrorBoundary>
};
